import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  Calendar,
  Users,
  MessageCircle,
  BarChart2,
  MoreHorizontal,
  Bell,
} from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { Avatar } from "../common/Avatar";

const TABS = [
  { id: "home", label: "Home", Icon: Home, path: "/" },
  { id: "events", label: "Events", Icon: Calendar, path: "/events" },
  { id: "friends", label: "Friends", Icon: Users, path: "/friends" },
  { id: "chat", label: "Chat", Icon: MessageCircle, path: "/chat" },
  { id: "stats", label: "Stats", Icon: BarChart2, path: "/stats" },
  { id: "more", label: "More", Icon: MoreHorizontal, path: "/more" },
];

export function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <header className='hidden md:flex sticky top-0 z-40 bg-primary-800 text-white h-16 items-center px-6 gap-4 shadow-md'>
      {/* Logo + wordmark */}
      <button
        onClick={() => navigate("/")}
        className='flex items-center gap-2.5 mr-6 shrink-0'
      >
        <img
          src='/logo.png'
          alt='Golf Kraken'
          className='h-9 w-9 rounded-xl object-contain'
        />
        <span className='text-lg font-bold tracking-tight'>Golf Kraken</span>
      </button>

      {/* Nav links */}
      <nav className='flex items-center gap-1 flex-1'>
        {TABS.map(({ id, label, Icon, path }) => {
          const isActive =
            path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(path);
          return (
            <button
              key={id}
              onClick={() => navigate(path)}
              className={[
                "flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-white/20 text-white"
                  : "text-white/70 hover:text-white hover:bg-white/10",
              ].join(" ")}
            >
              <Icon size={16} strokeWidth={isActive ? 2.5 : 1.8} />
              <span>{label}</span>
            </button>
          );
        })}
      </nav>

      {/* Right: notifications + user */}
      <div className='flex items-center gap-2 shrink-0'>
        <button className='p-2 rounded-lg hover:bg-white/10 transition-colors'>
          <Bell size={20} />
        </button>
        <button
          onClick={() => navigate("/more")}
          className='flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-white/10 transition-colors'
        >
          <Avatar
            src={user?.photoURL}
            name={user ? `${user.firstName} ${user.lastName}` : undefined}
            size='sm'
          />
          {user?.firstName && (
            <span className='text-sm text-white/80'>{user.firstName}</span>
          )}
        </button>
      </div>
    </header>
  );
}
